<template>
    <internal>
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg pb-48">
            <loading :showLoading="form.processing"/>
            <div :class="{'opacity-50':form.processing,'opacity-100':!form.processing}">
                <p class="text-lg font-medium mb-4">Add Result</p>
                <form @submit.prevent="submitForm">
                    <div class="  mb-8">
                        <div class="w-96 mb-3">

                            <breeze-label required="true" :value="'Select Year'"/>
                            <select required class="px-3 py-2 mt-2 w-full border border-gray-300 rounded"
                                    v-model="form.year">
                                <option v-for="year in years">
                                    {{ year }}
                                </option>
                            </select>
                            <breeze-input-error :message="form.errors?form.errors.year:''"/>
                        </div>
                        <div class="mb-3 w-96">
                            <breeze-label required="true" :value="'Upload Pdf'"/>
                            <input
                                class="form-control block w-full px-3 mt-2 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                type="file" id="formFile" @change="setFile" accept="application/pdf">

                            <breeze-input-error :message="form.errors?form.errors.pdf:''"/>
                        </div>

                    </div>
                    <!--                                            <button-link :href="route('internal.weekschedule.list',branchid)" class="bg-red-500 mr-4 hover:bg-red-400">Cancel</button-link>-->
                    <breeze-button :disabled="form.processing">Submit</breeze-button>
                    <span v-if="form.recentlySuccessful" class="text-green-500 mx-4">Result Upload Success</span>
                    <exception/>
                </form>
            </div>
        </div>
    </internal>
</template>

<script setup>
import Internal from '@/Pages/Internal/Internal'
import BreezeLabel from '@/Components/Label'
import Loading from '@/Components/Loading'
import {useForm} from "@inertiajs/inertia-vue3";
import {computed, defineProps, ref} from "vue";
import BreezeButton from '@/Components/Button'
import Select from "@/Components/Select";
import BreezeInputError from '@/Components/InputError'
import Exception from '@/Components/Exception'
import FormMultiselect from "@/Components/Forms/FormMultiselect.vue";

const i = ref(2015);
const props = defineProps({
    branch_course_id: String,
    years: Array
})
const form = useForm({
    year: '',
    pdf: [],
});

function submitForm() {
    console.log(props.branch_course_id);
    form.post(route('internal.courseyear.results.store', props.branch_course_id), {
        preserveScroll: true,
        onSuccess: () => {
            this.form.reset();
        },
    });
}

function setFile(e) {
    var data = e.target.files || e.dataTransfer.files;
    if (!data.length) return;
    form.pdf = data[0];
}
</script>
